import { changelog } from "../../../.velite";
import { sortByDateDesc, findBySlug } from "./collections";

export type ChangelogEntry = (typeof changelog)[number];

const SITE_URL = "https://scoopulator.app";

function absoluteUrl(pathOrUrl: string): string {
  return new URL(pathOrUrl, SITE_URL).toString();
}

export function getAllChangelogEntries(
  entries: readonly ChangelogEntry[] = changelog,
): ChangelogEntry[] {
  return sortByDateDesc(entries);
}

export function getChangelogEntryBySlug(
  slug: string,
  entries: readonly ChangelogEntry[] = changelog,
): ChangelogEntry | undefined {
  return findBySlug(entries, slug);
}

export function getChangelogMetadata(entry: ChangelogEntry) {
  const title = `${entry.title} - Scoopulator`;
  const description = entry.summary ?? "See what's new in Scoopulator.";
  const url = absoluteUrl(entry.url);
  const image = absoluteUrl(entry.image ?? "/logo.png");

  return {
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:type", content: "article" },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:url", content: url },
      { property: "og:image", content: image },
      { property: "og:image:alt", content: entry.title },
      { property: "article:published_time", content: entry.publishedAt },
      { property: "article:modified_time", content: entry.publishedAt },
      ...(entry.tags ?? []).map((tag) => ({
        property: "article:tag",
        content: tag,
      })),
      {
        name: "twitter:card",
        content: entry.image ? "summary_large_image" : "summary",
      },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
      { name: "twitter:image", content: image },
    ],
  };
}
